var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.527 8.30764C12.9126 8.30764 12.2634 8.49546 11.69 8.84425L11.1534 8.30764H9.96661V16.6153H12.3402V11.8681C12.3402 11.1848 13.0451 10.6813 13.527 10.6813H14.7138C15.1957 10.6813 15.9006 11.1848 15.9006 11.8681V16.6153H18.2743V11.8681C18.2743 9.66911 16.3682 8.30764 14.7138 8.30764H13.527Z",
    fill: "#B9C92B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.593 7.12083C8.24846 7.12083 8.77981 6.58948 8.77981 5.93403C8.77981 5.27857 8.24846 4.74722 7.593 4.74722C6.93755 4.74722 6.4062 5.27857 6.4062 5.93403C6.4062 6.58948 6.93755 7.12083 7.593 7.12083Z",
    fill: "#B9C92B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4062 8.30764V16.6153H8.77981V8.30764H6.4062Z",
    fill: "#B9C92B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.84578 0H21.8347C23.1456 0 24.2083 1.0627 24.2083 2.37361V21.3625C24.2083 22.6734 23.1456 23.7361 21.8347 23.7361H2.84578C1.53487 23.7361 0.472168 22.6734 0.472168 21.3625V2.37361C0.472168 1.0627 1.53487 0 2.84578 0ZM2.84578 2.37361V21.3625H21.8347V2.37361H2.84578Z",
    fill: "#B9C92B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.d27fb75879a2c32213265413d6a1cccc.svg";
export { ForwardRef as ReactComponent };